import {EntityType} from "../../gd/const/item";
import ModelEntity from "../model-entity";
import {SystemStatus} from "../../gd/const/system-status";

export default class Status extends ModelEntity {

    public companyId        : ID
    public systemStatus     : SystemStatus
    public name             : string
    public color            : number
    public description      : string | null
    public isDeleted        : boolean

    public disabled         : boolean       // used in Workflows to specify that this status cannot be used by cur user / at the moment
    public key              : number = 0    // used to quickly get current position of the status within models array and check next prev statuses

    constructor(data: any) {

        super(data.id, EntityType.STATUS)

        this.companyId      = data.companyId || gd.companyId
        this.systemStatus   = data.systemStatus
        this.name           = data.name
        this.color          = data.color
        this.description    = data.description || null
        this.isDeleted      = data.isDeleted || false

        this.disabled       = _.get(data,'disabled', false)

    }

    static initById(statusId: ID):Status {
        const sessionStatus = gd.session.statuses.get(statusId)
        return new Status(sessionStatus.toJSON())
    }

    get isClosed() {
        return this.systemStatus === gd.const.systemStatus.COMPLETED || this.systemStatus === gd.const.systemStatus.CANCELLED
    }

    get isOpen() {
        return !this.isClosed
    }

    public toJSON():JSONObject {
        return {
            companyId           : this.companyId,
            systemStatus        : this.systemStatus,
            name                : this.name,
            color               : this.color,
            description         : this.description,
            isDeleted           : this.isDeleted
        }
    }
}
